// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../core/resource.mjs";
import { path } from "../internal/utils/path.mjs";
export class Messages extends APIResource {
    /**
     * Retrieve a message by ID.
     */
    retrieve(messageID, options) {
        return this._client.get(path `/v1/messages/${messageID}`, options);
    }
    /**
     * List messages across all agents for the current user.
     */
    list(query = {}, options) {
        return this._client.get('/v1/messages/', { query, ...options });
    }
    /**
     * Search messages across the organization with optional agent filtering. Returns
     * messages with FTS/vector ranks and total RRF score.
     *
     * This is a cloud-only feature.
     */
    search(body, options) {
        return this._client.post('/v1/messages/search', { body, ...options });
    }
}
//# sourceMappingURL=messages.mjs.map